import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

// Subscribes to the OS "reduce motion" setting so GSAP-driven components can
// shorten or skip non-essential animation. SSR-safe (defaults to false).
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() =>
    typeof window !== 'undefined' && 'matchMedia' in window
      ? window.matchMedia(QUERY).matches
      : false,
  );

  useEffect(() => {
    if (!('matchMedia' in window)) return;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
